import { CSSProperties } from 'react'

import { SxProps } from '@mui/material'

const styles = {
  container: {} as SxProps,

  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    width: '100%',
    maxWidth: { xs: '100%', md: 600 },
    mx: 'auto'
  } as SxProps,

  shareLinkContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  } as SxProps,

  shareLinkTop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 1
  } as SxProps,

  shareLinkModalImage: {
    width: { xs: 60, md: 80 },
    height: 'auto',
    mb: 1
  } as SxProps,

  shareLinkModalPrimaryText: {
    fontWeight: 600
  } as SxProps,

  shareLinkModalSecondaryText: {
    color: 'text.secondary'
  } as SxProps,

  shareLinkModalTertiaryText: {
    color: 'text.secondary',
    fontSize: { xs: '0.875rem', md: '1rem' },
    mt: 1
  } as SxProps,

  linkText: {
    color: 'primary.main',
    fontWeight: 500
  } as CSSProperties,

  shareViaSocialMediaContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2
  } as SxProps,

  shareViaSocialMedia: {
    textAlign: 'center',
    color: 'text.secondary'
  } as SxProps,

  socialIconsContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 2
  } as SxProps,

  socialIconButton: {
    margin: '0 8px'
  } as CSSProperties,

  socialMediaIcon: {
    width: 36,
    height: 36
  } as CSSProperties,

  copyLinkContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5
  } as SxProps,

  copyLinkInstructionsText: {
    color: 'text.secondary'
  } as SxProps,

  copyLinkContentContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'center' },
    gap: 1
  } as SxProps,

  copyLinkText: {
    flex: 1,
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  } as SxProps
}

export default styles
